import { IS_COACH_INTRO_FEE_ENABLED } from 'constants/user';

export const CUSTOMER_MARKUP_RATE_DECIMAL = 0.1;
export const CUSTOMER_FEE_CENTS = 0; // In cents
export const COACH_FEE_CENTS = 0; // In cents
export const CREDIT_CARD_FEE_RATE_DECIMAL = 0.05;
export const COACH_INTRO_FEE_CENTS = 1000;

interface Params {
  priceUnitAmount: number;
  customerFeeCents?: number;
  coachFeeCents?: number;
  creditCardFeeRateDecimal?: number;
  coachIntroFeeUnitAmount?: number;
  currency?: string;
  includeCoachIntroFee?: boolean | undefined;
}

// NOTE: Do we need to do anymore to ensure we are only working with integers?
// We should be fine if we round all multiplication if we can trust priceUnitAmount
export const getLessonItemizedTotal = ({
  priceUnitAmount,
  customerFeeCents = CUSTOMER_FEE_CENTS,
  coachFeeCents = COACH_FEE_CENTS,
  creditCardFeeRateDecimal = CREDIT_CARD_FEE_RATE_DECIMAL,
  /**
   * @todo Add these. Maybe pass in coach details+user details and make this async and get the values instead of passing them in
   * @todo Add these. Maybe pass in coach details+user details and make this async and get the values instead of passing them in
   * @todo Add these. Maybe pass in coach details+user details and make this async and get the values instead of passing them in
   * @todo Add these. Maybe pass in coach details+user details and make this async and get the values instead of passing them in
   * @todo Add these. Maybe pass in coach details+user details and make this async and get the values instead of passing them in
   * @todo Add these. Maybe pass in coach details+user details and make this async and get the values instead of passing them in
   * @todo Add these. Maybe pass in coach details+user details and make this async and get the values instead of passing them in
   */
  coachIntroFeeUnitAmount = 0,
  currency,
  includeCoachIntroFee,
}: Params) => {
  /**
   * @note old way where it was a percentage fee
   */
  // const customerApplicationFeeUniteAmount = Math.ceil(
  //   priceUnitAmount * CUSTOMER_MARKUP_RATE_DECIMAL,
  // );

  const orderSubtotalUnitAmount = priceUnitAmount; // Sum of items

  // Fees
  const customerApplicationFeeUnitAmount = Math.ceil(customerFeeCents);
  const sellerApplicationFeeUnitAmount = Math.ceil(coachFeeCents); // Note: Paid by the coach (indirectly) after the transaction is complete
  const orderSubtotalWithPlatformFeesUnitAmount =
    orderSubtotalUnitAmount + customerApplicationFeeUnitAmount;

  const coachIntroFeeCents =
    IS_COACH_INTRO_FEE_ENABLED && includeCoachIntroFee === true ? COACH_INTRO_FEE_CENTS : 0;

  const creditCardFeeUnitAmount = Math.ceil(orderSubtotalUnitAmount * creditCardFeeRateDecimal);

  /**
   * @note (Fees Bounce keeps) - Application fee is the Stripe terminology for the platform service fee that Bounce receives
   */
  const applicationFeeTotal =
    customerApplicationFeeUnitAmount +
    sellerApplicationFeeUnitAmount +
    creditCardFeeUnitAmount +
    coachIntroFeeCents;

  /**
   * @note (What the customer pays) - Seller fee is not in the order total. This total is what is paid by the customer. The coach's fee is deducted after money has been received.
   */
  const orderTotalUnitAmount =
    orderSubtotalWithPlatformFeesUnitAmount + creditCardFeeUnitAmount + coachIntroFeeCents;

  /**
   * @note The coach receives the payment price minus the additional service fee from customer and the fee paid to us by the coach.
   */
  const coachAmountReceived = orderTotalUnitAmount - applicationFeeTotal;

  return {
    customerApplicationFee: customerApplicationFeeUnitAmount,
    sellerApplicationFee: sellerApplicationFeeUnitAmount,
    creditCardFee: creditCardFeeUnitAmount,
    orderSubtotal: orderSubtotalUnitAmount,
    orderTotal: orderTotalUnitAmount,
    orderSubtotalWithPlatformFeesUnitAmount,
    coachAmountReceived,
    applicationFeeTotal,
    // input
    priceUnitAmount,
    customerFeeCents,
    coachFeeCents,
    creditCardFeeRateDecimal,
    coachIntroFeeCents,
  };
};
